import React, { useState, useEffect } from "react";
import { Calendar } from "lucide-react";

const FloatingBookButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling past hero section (approximately 500px)
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <a
      href="https://bc-ice.janeapp.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 md:hidden bg-[#C2410C] text-white px-6 py-4 rounded-full font-bold shadow-xl hover:bg-[#9A3412] transition-all animate-bounce-subtle flex items-center gap-2"
      data-testid="floating-book-btn"
    >
      <Calendar className="w-5 h-5" />
      <span>Book Now</span>
    </a>
  );
};

export default FloatingBookButton;
